import { render, staticRenderFns } from "./view-application.vue?vue&type=template&id=0ffc61cc&"
import script from "./view-application.vue?vue&type=script&lang=js&"
export * from "./view-application.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports